import type { RouterConfig } from '@nuxt/schema'

export default <RouterConfig>{
  async scrollBehavior (to, _from, savedPosition) {

    if (history.state.stop) { return }

    if (history.state.smooth) {
      return {
        el: history.state.smooth,
        behavior: 'smooth'
      }
    }
    if (!to.hash && _from?.fullPath?.includes('/glossary/')) {
      return {
        top: 0,
        behavior: 'smooth'
      }
    }

    if (to.hash) {
      await nextTick()

      const el = await waitForElement(to.hash.replace('#', ''))
      if (!el) return
      if (window.innerWidth < 991) {
        const rect = el.getBoundingClientRect()
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop
        const marginTop = parseInt(getComputedStyle(el).marginTop) || 0
        const offset = rect.top + scrollTop - marginTop - 64
        return {
          top: offset,
          block: 'start',
          behavior: 'smooth'
        }
      } else {
        return {
          el,
          top: 64,
          // block: 'start',
          behavior: 'smooth'
        }
      }
    }

    // Scroll to the top of the window
    if (savedPosition) {
      return savedPosition
    } else {
      if (to?.query?.modal || _from?.query?.modal) {
        return;
      }
      return { top: 0 }
    }
  }
}


async function waitForElement (selector: string, retries = 10, delay = 100): Promise<HTMLElement | null> {
  for (let i = 0; i < retries; i++) {
    const el = document.getElementById(selector)
    if (el) return el
    await new Promise(resolve => setTimeout(resolve, delay))
  }
  return null
}
